import '../../../styles/components/loader.scss'
import Alpine from 'alpinejs'
import { appendPreloadFactory } from 'helpers/tools'
import { delegate } from 'helpers/events'
import { cross } from 'components/icons'

let esc = null

export default function () {
  let state = {
    open: false,
    loading: false,
    loader: null,
  }
  const wrapper = document.createElement('div')
  const preloadSetter = appendPreloadFactory()
  wrapper.innerHTML = MODAL_HTML
  document.body.appendChild(wrapper.firstElementChild)

  delegate('[data-modal-close]', 'click', (e) => {
    e.preventDefault()
    toggleModal(state, undefined, false)
    toggleLoader(state, false)
  })

  delegate('[data-modal]', 'click', (e) => {
    if (!e.target.closest('[data-modal-content]')) {
      e.preventDefault()
      toggleModal(state, undefined, false)
      toggleLoader(state, false)
    }
  })

  delegate('[data-modal-trigger]', 'mouseover', (e) => {
    const location = document.location
    const target = e.target.closest('[data-modal-trigger]')
    const config = parseConfig(target.dataset)
    const url = new URL(config.url || target.href, location)
    url.searchParams.append('_ajax', true)

    // prevent attacks
    if (!(location.hostname === url.hostname || !url.hostname.length)) return
    preloadSetter(url)
  })

  delegate('[data-modal-trigger]', 'click', (e) => {
    const location = document.location
    const target = e.target.closest('[data-modal-trigger]')
    const config = { center: false, ...parseConfig(target.dataset) }
    const url = new URL(config.url || target.href, location)
    url.searchParams.append('_ajax', true)

    // prevent attacks
    if (!(location.hostname === url.hostname || !url.hostname.length)) return

    document.querySelector('[data-modal]').style.display = null
    toggleLoader(state, true)

    fetch(url.href, FETCH_CONFIG)
      .then(async (resp) => {
        if (!resp.ok) throw new Error('Failed loading')
        return resp.text()
      })
      .then((content) => {
        toggleModal(state, { header: config.caption, visual: config.visual, chromeless: config.chromeless, center: config.center, content }, true)
        toggleLoader(state, false)
      })
      .catch((e) => {
        console.log(e)
        toggleModal(state, undefined, false)
        toggleLoader(state, false)
      })
    e.preventDefault()
  })
}

const escHandler = (state) => (e) => {
  if (e.keyCode === 27) toggleModal(state, undefined, false)
}

const toggleModal = (state, data = { header: null, visual: null, content: null, chromeless: false }, force) => {
  let { header, visual, content, center, chromeless } = data
  state.open = typeof force === 'undefined' ? !state.open : force
  Alpine.nextTick(() => {
    Alpine.store('page').hasOpenOverlay = state.open
  })

  // @TODO maybe refactor for XSS attacks?
  if (state.open) {
    if (!chromeless) {
      if (header || visual) {
        content =
          `<div class="relative flex items-center bg-blue-base text-white">
            ${visual ? `
              <div class="bg-gray-base w-full" aria-hidden="true" style="padding-top:${ 394 / 1080 * 100 }%"></div>
              ${visual}
            ` : ''}
            ${(header && visual) ? `
              <div class="absolute w-full bottom-0 left-0 bg-blue-base bg-opacity-60">
                <div class="mx-auto max-w-md pl-6 md:pl-2.5 pr-4 py-2 font-bold text-20">${header}</div>
              </div>
            ` : `
              <div class="w-full mx-auto max-w-md pl-6 md:pl-2.5 pr-4 py-2 font-bold text-20 bg-blue-base">${header}</div>
            `}
            <div class="absolute top-0 right-0">${ICON_CLOSE_HTML}</div>
          </div>` + content
      } else {
        content =
          `<div class="flex justify-end bg-blue-base text-white">${ICON_CLOSE_HTML}</div>` +
          content
      }
    }

    esc = escHandler(state)
    document.addEventListener('keydown', esc, false)
    document.body.style.overflow = 'hidden'
    if (!chromeless) document.querySelector('[data-modal-content]').classList.add('bg-white')
    if (center) {
      document.querySelector('[data-modal]').classList.add('flex')
      document.querySelector('[data-modal-inner]').classList.add('m-auto')
    }
    else document.querySelector('[data-modal-inner]').classList.add('mx-auto')
    document.querySelector('[data-modal-content]').innerHTML = content
  } else {
    if (esc) document.removeEventListener('keydown', esc, false)
    if (!chromeless) document.querySelector('[data-modal-content]').classList.remove('bg-white')

    document.querySelector('[data-modal]').classList.remove('flex')
    document.querySelector('[data-modal-inner]').classList.remove('m-auto', 'mx-auto')
    document.querySelector('[data-modal-content]').innerHTML = ''
    document.body.style.overflow = null
    document.querySelector('[data-modal]').style.display = 'none'
  }
}
const toggleLoader = (state, force) => {
  state.loading = typeof force === 'undefined' ? !state.loading : force

  if (state.loader) {
    state.loader.remove()
    state.loader = null
  }
  if (state.loading) {
    const loader = document.createElement('div')
    loader.classList.add(
      'loader',
      'text-white',
      'm-4',
      'fixed',
      'right-0',
      'bottom-0',
      'animate-spin'
    )
    document.querySelector('[data-modal]').appendChild(loader)
    state.loader = loader
  }
}

const parseConfig = (dataset) => {
  const rawConfig = JSON.parse(dataset.modalTrigger || '{}')
  return {
    ...BASE_CONFIG,
    ...(typeof rawConfig === 'string' ? { url: rawConfig } : rawConfig),
  }
}

const BASE_CONFIG = {
  url: null,
  caption: null,
  visual: null,
}

const FETCH_CONFIG = {
  mode: 'cors',
  credentials: 'same-origin',
}

const MODAL_HTML = `
<div data-modal class="fixed inset-0 overflow-y-scroll z-50" style="display:none">
  <div class="fixed inset-0 bg-blue-base bg-opacity-50" x-data @click="$dispatch('modal-close')"></div>
  <div data-modal-inner class="relative w-full max-w-lg py-6 px-4">
    <div data-modal-content></div>
  </div>
</div>
`

const ICON_CLOSE_HTML = `
<button class="cursor-pointer p-4" data-modal-close x-data @click="$dispatch('modal-close')">
  ${cross}
</button>
`
